import { SafeAreaView, View, ImageBackground } from 'react-native'
import LottieView from 'lottie-react-native'
import ProfileCard from '../components/ProfileCard'
import { RecentlySubmitted } from '../components/RecentlySubmitted'

const ProfileScreen = () => {
	return (
		<ImageBackground
			style={{ width: '100%', height: '100%', alignSelf: 'center' }}
		>
			{/* <LottieView source={require('../assets/animations/particles.json')} style={{ opacity: 0.8 }} autoPlay loop /> */}
			<SafeAreaView>
				<ProfileCard />
				<RecentlySubmitted />
			</SafeAreaView>
		</ImageBackground>
	)
}

export default ProfileScreen
